import React from "react";

import * as classes from "./logos.module.scss";

const Logos = () => {
  return (
    <div className={`mx-auto w-11/12 lg:w-5/6 `}>
      <div className="w-11/12 flex flex-row flex-wrap justify-between mx-auto my-20 items-center">
        <div className="w-31 md:w-18 my-4 ">
          <img
            alt="logos"
            src="/usecase-logos/coursLegendre.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/group-igs.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/bocconi.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/excelsiorCollege.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/hcfdc.png"
            style={{
              width: "70%",
              // height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/storelift.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/cognizant.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/Emlyon.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 my-4">
          <img
            alt="logos"
            src="/usecase-logos/tonsvenir.png"
            style={{
              width: "100%",
              height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
        <div className="w-31 md:w-18 hidden md:block my-4">
          <img
            alt="logos"
            src="/usecase-logos/ellipses.png"
            style={{
              width: "70%",
              // height: "100%",
              objectFit: "contain",
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Logos;
